<template>
  <div>
    <div v-if="hasHeader" class="modal-header">
      <h5 class="modal-title">{{ titulo }}</h5>
      <button
        v-if="dispensavel"
        type="button"
        class="btn btn-link close modal-close"
        aria-label="Dispensar"
        @click="$emit('dispensar')"
      >
        <i class="fas fa-times" />
      </button>
    </div>
    <div class="modal-body">
      <slot name="body" />
    </div>
    <div v-if="hasFooter" class="modal-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HcModalSimples",
  props: {
    titulo: {
      type: String,
      required: true
    },
    dispensavel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader,
    hasFooter
  }
};

function hasHeader() {
  return this.$slots.header != null || this.titulo != null;
}

function hasFooter() {
  return this.$slots.footer != null;
}
</script>
